/** Prefer AI guidance when loaded; show local rules only after API completes without AI. */
export function resolveAiText(loading, aiValue, localValue) {
  if (loading) return null;
  return aiValue ?? localValue;
}

export function resolveAiList(loading, aiList, localList) {
  if (loading) return [];
  if (Array.isArray(aiList) && aiList.length) return aiList;
  return localList ?? [];
}
